import { parseError } from '../../../helpers/errorUtils';
import { DataDogLogger } from '../../../hooks/useDataDogLogger';
import { DATADOG_ACTIONS } from '../constants';

/**
 * Invokes a deviceSdk method and reports any failure to DataDog.
 *
 * Most terminal SDK calls (close/exit/decline/cancel/activation) are
 * fire-and-forget — not awaited, not wrapped — so a native-bridge failure or a
 * rejected promise is swallowed silently. This awaits the call and, on failure,
 * emits a template_error (flow: 'sdk') tagged with the method name. Fire it
 * without awaiting at the call site so the surrounding flow (e.g. stopSession)
 * is unaffected; the catch still reports async rejections.
 */
export const trackSdkCall = async (
  method: string,
  call: () => unknown,
  logger: DataDogLogger,
) => {
  try {
    await call();
  } catch (err) {
    const { errorCode, errorMessage, statusCode } = parseError(err);

    logger.error(DATADOG_ACTIONS.errors.template_error, {
      flow: 'sdk',
      method,
      statusCode,
      errorCode: errorCode ?? 'UNKNOWN',
      errorMessage,
    });
  }
};
